import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import React, {
  Component,
} from 'react';
import generalClasses from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import {
  IGoogleMapField,
} from '../formFields';
import {
  MapContainer,
} from '../MapContainer/MapContainer';
import classes from './GoogleMapField.module.scss';

export const defaultPosition = {
  latitude: 29.9577874,
  longitude: 31.3133217,
};

interface IProps extends IGoogleMapField {
  onChange(name: string, value: {latitude: number; longitude: number }): any;
}

class GoogleMapField extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
    if (!this.props.value) {
      this.handelMarkDrag(defaultPosition.latitude, defaultPosition.longitude);
    }
  }

  handelMarkDrag = (latitude: number, longitude: number): void => {
    const position = {
      latitude,
      longitude,
    };
    this.props.onChange(this.props.name, position);
  };

  render() {
    let markPosition;
    if (this.props.value) {
      markPosition = this.props.value;
    } else {
      markPosition = defaultPosition;
    }
    return (
      <div className={classNames(classes.map, generalClasses.filed)}>
        <MapContainer
          markPosition={markPosition}
          onMarkDrag={this.handelMarkDrag}
        />
        <Typography variant="caption" gutterBottom className={classNames(classes.label)}>
          {this.props.label}
        </Typography>
      </div>
    );
  }
}

export default GoogleMapField;
